import React from 'react';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import defaultStyles from './button.scss';

enum ElementName {
    a = 'a',
    button = 'button',
}

interface Props {
    children: React.ReactNode;
    styles: typeof defaultStyles;
    src: string;
}


const Base = <P extends Props & { elementName: ElementName }>(props: P) => {
    const { styles, src, children, elementName, ...rest } = props as any;

    return React.createElement(
        elementName,
        { ...rest, className: styles.button },
        <span className={styles.container}>
            <SVGIcon style={{image: styles.icon}}  src={src} />
            <span className={styles.label}>{children}</span>
        </span>
    );
};

type ButtonProps = Props & React.ButtonHTMLAttributes<HTMLButtonElement>;
type AnchorProps = Props & React.AnchorHTMLAttributes<HTMLAnchorElement>;

function Button(props: ButtonProps) {
    return <Base elementName={ElementName.button} {...props} />;
}
function Anchor(props: AnchorProps) {
    return <Base elementName={ElementName.a} {...props} />;
}

const StyledAnchor = Styled(defaultStyles)(Anchor as React.StatelessComponent<AnchorProps>);

export { StyledAnchor as Anchor };
export default Styled(defaultStyles)(Button as React.StatelessComponent<ButtonProps>);
